import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import {
  bookingsCalendarClick,
  bookingsCalendarDatePickerLoad,
  bookingsCalendarErrorMessages,
  bookingsCalendarPageLoaded,
} from '@wix/bi-logger-wixboost-ugc/v2';
import { bookingsUoUFlowWidgetLoadSrc16Evid32 } from '@wix/bi-logger-bookings-data/v2';
import {
  BookingsQueryParams,
  getUrlQueryParamValue,
} from '@wix/bookings-catalog-calendar-viewer-utils';
import { DailyAgendaState } from '../../components/DailyAgenda/state/types';
import {
  GetState,
  Subscribe,
} from '../../components/DailyAgenda/state/createState';

export class DailyAgendaBiLogger {
  private readonly viewerBiLogger;
  static readonly PAGE_NAME = 'daily_agenda_widget_v2';
  constructor(
    private readonly flowAPI: ControllerFlowAPI,
    private readonly getState: GetState,
  ) {
    this.viewerBiLogger = flowAPI.bi;
    this.initializeDefaults();
  }

  private mapStateToDefaultBiParams(state: DailyAgendaState) {
    return {
      selectedTimezone: state?.selectedTimezone,
      selectedDate: state?.selectedDate,
      selectedFilters: JSON.stringify(state?.selectedFilters),
      selectedRange: JSON.stringify(state?.selectedRange),
      businessProperties: JSON.stringify({
        language: state?.languageSettings.language,
        countryCode: state?.languageSettings.countryCode,
      }),
      // TODO: add layout
    };
  }

  private initializeDefaults() {
    this.viewerBiLogger?.updateDefaults({
      pageName: DailyAgendaBiLogger.PAGE_NAME,
      ...this.mapStateToDefaultBiParams(this.getState()),
      referralInfo: getUrlQueryParamValue(
        this.flowAPI.controllerConfig.wixCodeApi,
        BookingsQueryParams.REFERRAL,
      ),
    });
  }

  subscribeToStateChanges(subscribe: Subscribe) {
    subscribe(
      ({
        selectedDate,
        selectedTimezone,
        selectedRange,
        selectedFilters,
        languageSettings,
        settings,
      }) => ({
        selectedDate,
        selectedTimezone,
        selectedRange,
        selectedFilters,
        languageSettings,
        settings,
      }),
      () => {
        this.update();
      },
    );
  }

  update() {
    this.viewerBiLogger?.updateDefaults(
      this.mapStateToDefaultBiParams(this.getState()),
    );
  }

  reportClick(
    component: string,
    element: string,
    properties?: Record<string, any>,
  ) {
    this.viewerBiLogger?.report(
      bookingsCalendarClick({
        component,
        element,
        properties: properties ? JSON.stringify(properties) : undefined,
      }),
    );
  }

  reportDatePickerLoad() {
    this.viewerBiLogger?.report(bookingsCalendarDatePickerLoad({}));
  }

  reportError(error: string) {
    this.viewerBiLogger?.report(
      bookingsCalendarErrorMessages({ errorMessage: error }),
    );
  }

  reportPageLoaded() {
    this.viewerBiLogger?.report(bookingsCalendarPageLoaded({}));
  }

  reportWidgetLoad() {
    this.viewerBiLogger?.report(
      bookingsUoUFlowWidgetLoadSrc16Evid32({
        widget_name: DailyAgendaBiLogger.PAGE_NAME,
        referralInfo: getUrlQueryParamValue(
          this.flowAPI.controllerConfig.wixCodeApi,
          BookingsQueryParams.REFERRAL,
        ),
      }),
    );
  }
}
